/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../onboarding/account/common';
import '../status';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "accountCreation": {
                "nested": {
                  "service": {
                    "nested": {
                      "AccountCreationRequest": {
                        "fields": {
                          "email": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "password": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "countryCode": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "langCode": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "timeZone": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "ipAddress": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "isCbdSeller": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "recaptchaResponse": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "captchaType": {
                            "type": "squareup.onboarding.account.common.CaptchaType",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      },
                      "AccountCreationResponse": {
                        "fields": {
                          "success": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "errors": {
                            "type": "squareup.onboard.activation.status.Error",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "userToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "alreadyActivated": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "registerClientErrorMessage": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "existingMerchant": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.accountCreation?.nested?.service?.nested?.AccountCreationRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.accountCreation?.nested?.service?.nested?.AccountCreationResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AccountCreationRequest @ squareup/onboard/activation/accountCreation/service.proto at 9:1
 */
export const AccountCreationRequest = $root.lookupType('squareup.onboard.activation.accountCreation.service.AccountCreationRequest');
fixType(AccountCreationRequest, {
  email: {
    required: true
  },
  password: {
    required: true
  },
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(AccountCreationRequest);
/**
 * SOURCE AccountCreationResponse @ squareup/onboard/activation/accountCreation/service.proto at 44:1
 */
export const AccountCreationResponse = $root.lookupType('squareup.onboard.activation.accountCreation.service.AccountCreationResponse');
fixType(AccountCreationResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(AccountCreationResponse);